import { ICriteria } from "src/app/core/services/criteria.interface";
import { HttpParams } from "@angular/common/http";

export class LiftCriteria implements ICriteria {
  pageSize: number = 50;
  page: number = 1;
  orderby: string = 'LiftModuleCode asc';
  searchTerm: string = null;
  filterActive: string = 'active';

  paramsExport(): HttpParams {
    let params = new HttpParams()
      .set('page', String(this.page))
      .set('orderby', this.orderby)
      .set('pageSize', String(this.pageSize));

    if (this.searchTerm && this.filterActive == 'active') {
      params = params.set('filter', 'IsActive == True and (LiftModuleCode.Contains("' + this.searchTerm + '") or AddressTown.Contains("' + this.searchTerm + '") or AddressStreet.Contains("' + this.searchTerm + '"))')
    }

    if (this.searchTerm && this.filterActive == 'inActive') {
      params = params.set('filter', 'IsActive == False and (LiftModuleCode.Contains("' + this.searchTerm + '") or AddressTown.Contains("' + this.searchTerm + '") or AddressStreet.Contains("' + this.searchTerm + '"))')
    }

    if (this.searchTerm && this.filterActive == 'all') {
      params = params.set('filter', 'LiftModuleCode.Contains("' + this.searchTerm + '") or AddressTown.Contains("' + this.searchTerm + '") or AddressStreet.Contains("' + this.searchTerm + '")')
    }

    if (!this.searchTerm && this.filterActive == 'active') {
      params = params.set('filter', 'IsActive == True')
    }

    if (!this.searchTerm && this.filterActive == 'inActive') {
      params = params.set('filter', 'IsActive == False')
    }

    return params;
  }
}
